import React from "react";
import { format } from "date-fns";
import { faListAlt, faStickyNote } from "@fortawesome/free-regular-svg-icons";

import { WithIcon, WithTooltip } from "../../shared/table-helpers";
import { DATE_FNS_SHORT_DATE_FORMAT } from "../../shared/constants";
import { DueDateFilterButton } from "../../components/table/components/dueDateFilterButton";
import { Checkbox, Select } from "../../components/form-inputs/plain-inputs";

const coreColumns = [
    {
        Header: "Upc",
        accessor: "upc",
        maxWidth: 150,
    },
    {
        Header: "Feed ID",
        accessor: "feedId",
        maxWidth: 282,
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: "Client",
        accessor: "client",
    },
    {
        Header: "Received Date",
        accessor: "receiveDate",
        filterable: true,
        maxWidth: 132,
        Filter: ({ filter, onChange }) => {
            return <DueDateFilterButton filterProp={filter} onChangeProp={onChange} />;
        },
        Cell: (row) => {
            const dateString = row.value ? format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT) : "";

            return WithTooltip(dateString);
        },
    },
    {
        Header: "Turnaround Date",
        accessor: "turnAroundDate",
        filterable: true,
        maxWidth: 132,
        Filter: ({ filter, onChange }) => {
            return <DueDateFilterButton filterProp={filter} onChangeProp={onChange} />;
        },
        Cell: (row) => {
            const dateString = row.value ? format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT) : "";

            return WithTooltip(dateString);
        },
    },
    {
        Header: WithIcon("Note", faStickyNote),
        accessor: "note",
        filterable: false,
        sortable: false,
        style: { whiteSpace: "unset" },
    },
];

export const buildColumns = (updateSelectedUpc, setAllUpcs, idList, workflowStatus) => {
    return [
        {
            Header: (props) => {
                const value = idList.length === props.data.length;

                return (
                    <Checkbox
                        name="selected-state"
                        value={value}
                        onChange={(e) => {
                            setAllUpcs(value ? [] : props.data.map((d) => d));
                        }}
                    />
                );
            },
            accessor: "id",
            filterable: false,
            sortable: false,
            Cell: (row) => {
                return (
                    <Checkbox
                        name={`select_${row.original.id}`}
                        value={idList.includes(row.value)}
                        onChange={(e) => {
                            updateSelectedUpc(row.original, e.currentTarget.value);
                        }}
                    />
                );
            },
            width: 65,
            className: "txt-center",
        },
        ...coreColumns,
        {
            Header: "Status",
            accessor: "statusId",
            filterMethod: (filter, row) => {
                const value = filter.value === "true";

                if (filter.value === "all") {
                    return true;
                }

                return row[filter.id] === value;
            },
            Filter: ({ filter, onChange }) => {
                return <Select onChange={(event) => onChange(event.target.value)} style={{ width: "100%" }} value={filter ? filter.value : ""} options={workflowStatus.list} />;
            },
            Cell: (row) => {
                return workflowStatus.map[row.value];
            },
        },
        {
            Header: WithIcon("Attributes Count", faListAlt),
            filterable: false,
            sortable: false,
            width: 75,
            accessor: "attributesCount",
            style: { textAlign: "center" },
        },
    ];
};

export const buildSearchColumns = (workflowStatus) => {
    return [
        ...coreColumns,
        {
            Header: "Status",
            accessor: "statusId",
            filterMethod: (filter, row) => {
                const value = filter.value === "true";

                if (filter.value === "all") {
                    return true;
                }

                return row[filter.id] === value;
            },
            Filter: ({ filter, onChange }) => {
                return <Select onChange={(event) => onChange(event.target.value)} style={{ width: "100%" }} value={filter ? filter.value : ""} options={workflowStatus.list} />;
            },
            Cell: (row) => {
                return workflowStatus.map[row.value];
            },
        },
    ];
};

export const DEFAULT_SORT = [
    {
        id: "receiveDate",
        desc: false,
    },
];

export const DEFAULT_FILTER = [];
